import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "data-panel" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#6b7280","font-size":"14px"}
}
const _hoisted_3 = {
  key: 1,
  class: "data-settings"
}
const _hoisted_4 = { class: "data-field" }
const _hoisted_5 = { class: "data-field" }
const _hoisted_6 = { class: "data-field" }
const _hoisted_7 = { class: "data-field" }
const _hoisted_8 = { class: "data-field" }
const _hoisted_9 = { class: "data-field" }
const _hoisted_10 = {
  key: 0,
  class: "data-error"
}
const _hoisted_11 = {
  key: 1,
  class: "data-success"
}
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "data-title" }, "Pagamento e Contrato", -1)),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, "Plano", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.payPlan) = $event)),
              class: "data-select"
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("option", { value: "basico" }, "Básico", -1),
              _createElementVNode("option", { value: "normal" }, "Normal", -1),
              _createElementVNode("option", { value: "completo" }, "Completo", -1)
            ]))], 512), [
              [_vModelSelect, $setup.payPlan]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Máximo de usuários", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.payMaxUsers) = $event)),
              type: "number",
              min: "1"
            }, null, 512), [
              [
                _vModelText,
                $setup.payMaxUsers,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "Valor do contrato (R$)", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.payContractValue) = $event)),
              type: "number",
              min: "0",
              step: "0.01"
            }, null, 512), [
              [
                _vModelText,
                $setup.payContractValue,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[11] || (_cache[11] = _createElementVNode("label", null, "Dia do vencimento (1–28)", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.payDay) = $event)),
              type: "number",
              min: "1",
              max: "28"
            }, null, 512), [
              [
                _vModelText,
                $setup.payDay,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[13] || (_cache[13] = _createElementVNode("label", null, "Status do pagamento", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.payStatus) = $event)),
              class: "data-select"
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("option", { value: "em-dia" }, "Em dia", -1),
              _createElementVNode("option", { value: "atrasado" }, "Atrasado", -1),
              _createElementVNode("option", { value: "suspenso" }, "Suspenso", -1)
            ]))], 512), [
              [_vModelSelect, $setup.payStatus]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[14] || (_cache[14] = _createElementVNode("label", null, "Último pagamento em", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.payLastAt) = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, $setup.payLastAt]
            ])
          ]),
          ($setup.payError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($setup.payError), 1))
            : _createCommentVNode("", true),
          ($setup.paySuccess)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString($setup.paySuccess), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn-admin-primary",
            type: "button",
            disabled: $setup.paySaving,
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.savePayment && $setup.savePayment(...args)))
          }, _toDisplayString($setup.paySaving ? 'Salvando...' : 'Salvar pagamento'), 9, _hoisted_12)
        ]))
  ]))
}